module.exports = __webpack_public_path__ + "img/restaurar64.bda53ac1.png";